import { contractConstants } from '../../constants'
import { defaultService } from '../../services'
import { errorMessages } from '../../messages'
import { alertActions } from '../'

export const contractActions = {
  status,
  load,
  search,
  select,
  delete: _delete,
}

/*******************
  method 반드시 이렇게..

  GET    = Read
  POST   = Create
  PUT    = Update
  DELETE = Delete
********************/

/*********
 status
**********/

function status() {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService(
      'post',
      '/swg/contract/read/contractStatusInfo.do',
      'pagenum=0' +
      '&pagesize=10' +
      '&searchCol=1' +
      '&cntrctStateCd=ALL' +
      '&atchfileGrpSeq=0'
    )
    .then(
      response => {
        dispatch(success(response))
      },
      error => {
        dispatch(failure(error))
        dispatch(alertActions.error(errorMessages.systemError))
      }
    )
  }
  function request() {
    return {
      type: contractConstants.STATUS_REQUEST
    }
  }
  function success(response) {
    return {
      type: contractConstants.STATUS_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: contractConstants.STATUS_FAILURE,
      response
    }
  }
}

/*********
 로딩
**********/

function load(params) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: 'http://192.168.1.7:8080/portal/contract'
    })
    .then(
      response => {
        dispatch(success(response))
      },
      error => {
        dispatch(failure(error))
        dispatch(alertActions.error({
          title: null,
          message: errorMessages.systemError
        }))
      }
    )
  }
  function request() {
    return {
      type: contractConstants.LOAD_REQUEST
    }
  }
  function success(response) {
    return {
      type: contractConstants.LOAD_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: contractConstants.LOAD_FAILURE,
      response
    }
  }
}

/*********
 검색
**********/

function search(keyword) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'post',
      endPoint: '/swg/contract/read/contractBox.do',
      params: 'pagenum=0&pagesize=10&searchCol=1&searchWd=' + keyword
    })
    .then(
      response => {
        dispatch(success(response))
      },
      error => {
        dispatch(failure(error))
        dispatch(alertActions.error({
          title: null,
          message: errorMessages.systemError
        }))
      }
    )
  }
  function request() {
    return {
      type: contractConstants.SEARCH_REQUEST
    }
  }
  function success(response) {
    return {
      type: contractConstants.SEARCH_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: contractConstants.SEARCH_FAILURE,
      response
    }
  }
}

/*********
 셀렉트
**********/

function select(params) {
  return async dispatch => {
    dispatch(request())
  }
  function request() {
    return {
      type: contractConstants.SELECT_REQUEST,
      params
    }
  }
}

/*********
 삭제
**********/

function _delete(id) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'post',
      endPoint: '/swg/contract/delete/contractStatusInfoListData.do',
      params: 'cntrctNo='+ id +'&menuId=101&tmp='
    })
    .then(
      response => {
        dispatch(success(response))
      },
      error => {
        dispatch(failure(error))
        dispatch(alertActions.error({
          title: null,
          message: errorMessages.systemError
        }))
      }
    )
  }
  function request() {
    return {
      type: contractConstants.DELETE_REQUEST
    }
  }
  function success(response) {
    return {
      type: contractConstants.DELETE_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: contractConstants.DELETE_FAILURE,
      response
    }
  }
}
